import * as React from "react";
import { useMemo } from "react";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import { Select } from "components/common";
const StatusFilter = ({ value, onSelect, selectedValues }) => {
  const statusesOptions = useMemo(
    () => Object.keys(SECURITY_EVENT_STATUSES).map((status) => ({
      label: SECURITY_EVENT_STATUSES[status],
      value: status,
      disabled: selectedValues.includes(status)
    })),
    [selectedValues]
  );
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: "Select a status",
      clearable: false,
      menuIsOpen: true,
      options: statusesOptions,
      onChange: onSelect,
      value
    }
  );
};
export default StatusFilter;
